import { useId } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect, WrappedTextArea } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from '../FormDataContext';
import type { IForm } from '../types';

export function Task({ index, modal }: { index: number; modal?: boolean }) {
  const { t } = useAppTranslation(['demand', 'ServicesOpPl', 'common']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IForm>();

  const { serviceType } = useFormDataContext();
  const id = useId();

  if (
    (serviceType?.full_stop_description || serviceType?.comment_by_selection) &&
    !serviceType?.type_stops.length
  )
    return null;

  const showSelect =
    (serviceType?.full_stop_description || serviceType?.comment_by_selection) &&
    serviceType.type_stops.length;
  const showDescription =
    serviceType?.full_stop_description || !serviceType?.comment_by_selection;

  const select = showSelect && (
    <Controller
      control={control}
      name={`stops.${index}.type_stop_id`}
      rules={{
        required: t('common:msg.required_field'),
        shouldUnregister: true,
      }}
      render={({ field }) => (
        <WrappedSelect
          {...field}
          isOnModal={modal}
          error={!!errors.stops?.[index]?.type_stop_id?.message}
          className="h-10 flex-1"
          label={t('demand:stopType')}
          id={id}
          innerClassName="min-w-0"
        >
          <option value="" hidden>
            {t('demand:addresses.addressForm.activity.select_load')}
          </option>
          {serviceType.type_stops?.map(({ id, name }, index) => (
            <option key={index} value={id}>
              {name}
            </option>
          ))}
        </WrappedSelect>
      )}
    />
  );

  const description = showDescription && (
    <Controller
      control={control}
      name={`stops.${index}.description`}
      rules={{
        required: t('common:msg.required_field'),
        minLength: {
          value: 20,
          message: t('common:msg.min_characters', { min: 20 }),
        },
        shouldUnregister: true,
      }}
      render={({ field }) => (
        <WrappedTextArea
          {...field}
          onChange={(e) => field.onChange(e.target.value)}
          className="flex-1"
          innerClassName="min-w-0"
          id={id}
          value={field.value ?? ''}
          isOnModal={modal}
          placeholder={t(
            'demand:addresses.addressErrandForm.descriptionPlaceholder'
          )}
          label={t('common:description')}
          rows={1}
          error={!!errors.stops?.[index]?.description?.message}
        />
      )}
    />
  );
  return (
    <>
      {select}
      {description}
    </>
  );
}
